import { usePermissions } from '@/auth/PermissionsContext';
import { Screen404 } from '@/pages/404/404';
import React from 'react';

type RequirePermissionProps = {
  anyOf: string[];
  children: React.ReactNode;
};

/**
 * Guard de rota baseado em permissões.
 * - Dono principal (is_primary) passa via hasAnyPermission, exceto em store read_only
 *   (só permissões view_*).
 * - Caso contrário → renderiza 404 (sem revelar que a rota existe).
 */
export function RequirePermission({ anyOf, children }: RequirePermissionProps) {
  const { hasAnyPermission, isLoaded } = usePermissions();

  // Aguarda permissões carregarem antes de bloquear
  if (!isLoaded) return null;

  if (hasAnyPermission(anyOf)) {
    return <>{children}</>;
  }

  return <Screen404 />;
}
